import { TrendingUp } from "lucide-react";
import type { ModuleSpec } from "../types";

/**
 * Customer Insights — the renamed/rebuilt CDP entry point.
 *
 * Replaced the original "Dashboard" (which was a tile grid of inventory
 * counts duplicating the sidebar). The new page is a real trend view with
 * profile-growth, top events, segment sizes, consent breakdown, goal
 * funnel, and identity health. Currently renders against placeholder data;
 * wire to the insights API when that ships.
 *
 * Route stays at `/customers/dashboard` so existing bookmarks keep working.
 */
export const customerDashboardSpec: ModuleSpec = {
  id: "customer-dashboard",
  icon: TrendingUp,
  i18n: {
    namespace: "modules",
    titleKey: "customer-dashboard.title",
    descriptionKey: "customer-dashboard.description",
  },
  nav: {
    path: "/customers/dashboard",
    group: "observe",
    order: 5,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Customer trends, top events, and conversion signals",
  },
};
